//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  nuxtI18n: {
    paths: {
      br: '/institucional',
      en: '/about-us',
      es: '/institucional'
    }
  },

  async asyncData({ $api }) {
    try {
      const { data } = await $api.institutional.show()

      return data
    } catch (err) {
      $api.instance.handleResponseError(err)
    }
  },

  data() {
    return {
      currentMenuActive: 'about-us',
      institutional: {},
      timelines: [],
      categories: [],
      presidency: [],
      directors: [],
      aboutUsVideo: {
        display: false,
        show: false
      },
      rewardsTabActive: 0
    }
  },

  head() {
    return this.$helpers.seoBuilder(this, {
      staticTitle: this.$t('title')
    })
  },

  computed: {
    breadcrumbs() {
      return [
        {
          name: this.$t('home'),
          path: '/'
        },
        {
          name: this.$t('title'),
          path: '/institucional'
        }
      ]
    },

    hasCertificates() {
      let hasCertificates = false

      if (this.categories && this.categories.length > 0) {
        this.categories.forEach((category) => {
          if (category.certificates && category.certificates.length > 0) {
            hasCertificates = true
          }
        })
      }

      return hasCertificates
    }
  },

  mounted() {
    this.registerScrollEvent()
  },

  beforeDestroy() {
    this.unregisterScrollEvent()
  },

  methods: {
    registerScrollEvent() {
      window.addEventListener('scroll', this.onScroll)
    },

    unregisterScrollEvent() {
      window.removeEventListener('scroll', this.onScroll)
    },

    onScroll() {
      const scrollTop =
        (window.pageYOffset || document.scrollTop) - (document.clientTop || 0)
      const menuHeight = this.$refs.navigation.offsetHeight
      const topDistance = scrollTop + menuHeight
      const sections = document.querySelectorAll('[data-section]')

      const passedSections = Array.from(sections).filter((section) => {
        const sectionTop = section.offsetTop
        const sectionOffset = section.getAttribute('data-offset')
        const top = sectionTop + (sectionOffset ? parseInt(sectionOffset) : 0)

        return topDistance >= top
      })

      if (passedSections.length > 0) {
        const lastSection = passedSections[passedSections.length - 1]
        const sectionName = lastSection.getAttribute('data-section')

        this.currentMenuActive = sectionName
      }
    },

    setMenuActive(event) {
      const target = event.target
      const menu = target.getAttribute('data-menu')
      const section = document.querySelector(`[data-section="${menu}"]`)
      const offset = section.getAttribute('data-offset')

      this.$scrollTo(section, 700, {
        offset: offset ? parseInt(offset) : 0
      })
    },

    openAboutUsVideo(videoUrl) {
      this.aboutUsVideo.display = !this.aboutUsVideo.display
      this.aboutUsVideo.url = videoUrl

      setTimeout(() => {
        this.aboutUsVideo.show = !this.aboutUsVideo.show
      }, 200)
    },

    closeAboutUsVideo() {
      this.aboutUsVideo.show = !this.aboutUsVideo.show

      setTimeout(() => {
        this.aboutUsVideo.display = !this.aboutUsVideo.display
        this.aboutUsVideo.url = ''
      }, 300)
    },

    setRewardsTabActive(event) {
      const target = event.target
      const index = target.getAttribute('data-index')

      this.rewardsTabActive = parseInt(index)
    }
  }
}
